/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentDetailsTaxComplianceStatus {
    REQUESTED = 'REQUESTED',
    SUBMITTED = 'SUBMITTED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}
